var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBouclier(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.98 65.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#e6007e;stroke-linecap:round;stroke-width:2px;}.cls-1,.cls-3{stroke-miterlimit:10;}.cls-2,.cls-3{fill:#e6007e;}.cls-3{stroke:#e71d73;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "syndicat"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.8,14.61A29.8,29.8,0,0,0,1,33,32,32,0,0,0,55.61,55.61a32,32,0,0,0,0-45.24h0A31.79,31.79,0,0,0,33,1a29.47,29.47,0,0,0-17.9,5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.53,11.62a1.57,1.57,0,1,0-1.11-.46A1.57,1.57,0,0,0,10.53,11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.84,43a.66.66,0,0,1-.66-.66.64.64,0,0,1,.08-.3c.3-.58.56-1.13.79-1.69a.66.66,0,0,1,1.22.51c-.24.59-.52,1.18-.84,1.79a.63.63,0,0,1-.59.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.33,56.61a.73.73,0,0,1-.3-.07C22,51,15.48,41.69,15.48,31.66V18.3a.67.67,0,0,1,.73-.66c6.53.67,12.12-1.7,16.61-7a.67.67,0,0,1,.5-.23.64.64,0,0,1,.5.23c3.94,4.5,9.56,6.87,16.7,7a.66.66,0,0,1,.65.66V29.18a.66.66,0,0,1-1.32,0V18.94c-6.93-.29-12.48-2.61-16.51-6.91-4.53,5.1-10.09,7.44-16.53,7V31.66c0,9.43,6.16,18.22,16.52,23.55A34.05,34.05,0,0,0,44.8,45.87a.66.66,0,0,1,1.05.8,35.33,35.33,0,0,1-12.23,9.87A.73.73,0,0,1,33.33,56.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.05,36.81l-.13,0A.66.66,0,0,1,49.4,36c.13-.65.23-1.3.31-2a.66.66,0,1,1,1.32.12v0c-.08.69-.19,1.38-.32,2.05a.67.67,0,0,1-.65.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.33,52.28A.62.62,0,0,1,33,52.2c-8.62-4.85-13.77-12.5-13.77-20.46V22.09a.65.65,0,0,1,.63-.66A20.26,20.26,0,0,0,33,15.83a.65.65,0,0,1,.87,0,24,24,0,0,0,13,5.32.66.66,0,0,1,.59.66v10c0,8-5.15,15.61-13.77,20.46a.61.61,0,0,1-.32.08ZM20.56,22.71v9c0,7.38,4.76,14.51,12.77,19.12,8-4.61,12.77-11.74,12.77-19.13V22.37a25.17,25.17,0,0,1-12.67-5.18A21.4,21.4,0,0,1,20.56,22.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.44,39.38a.65.65,0,0,1-.47-.2l-3.72-3.72a.66.66,0,0,1,.94-.93l3.25,3.25,9-9a.66.66,0,0,1,.94,0,.65.65,0,0,1,0,.93h0l-9.49,9.49a.65.65,0,0,1-.47.2Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBouclier);
export default __webpack_public_path__ + "static/media/bouclier.740eff67e1d20ab744c8d068eb5eb585.svg";
export { ForwardRef as ReactComponent };